import { useNextCalendarApp, ScheduleXCalendar } from '@schedule-x/react';
import {
  createViewDay,
  createViewWeek,
  createViewMonthGrid,
  createViewMonthAgenda,
} from '@schedule-x/calendar';
import { createEventsServicePlugin } from '@schedule-x/events-service';
import '@schedule-x/theme-default/dist/index.css';
import { useEffect, useMemo } from 'react';

export interface CalendarEvent {
  id: string;
  title: string;
  start: string; // 'YYYY-MM-DD HH:mm' or 'YYYY-MM-DD'
  end: string;
  calendarId?: string;
  description?: string;
}

interface Props {
  events: CalendarEvent[];
  onEventClick?: (eventId: string) => void;
}

export function Calendar({ events, onEventClick }: Props) {
  const eventsService = useMemo(() => createEventsServicePlugin(), []);

  const calendar = useNextCalendarApp({
    views: [
      createViewMonthGrid(),
      createViewWeek(),
      createViewDay(),
      createViewMonthAgenda(),
    ],
    defaultView: createViewMonthGrid().name,
    events,
    locale: 'ja-JP',
    weekOptions: {
      // 月曜始まり
      gridHeight: 600,
      nDays: 7,
    },
    plugins: [eventsService],
    callbacks: {
      onEventClick(event) {
        onEventClick?.(String(event.id));
      },
    },
  });

  useEffect(() => {
    if (!calendar) return;
    // events を更新
    eventsService.set(events);
  }, [calendar, eventsService, events]);

  return <ScheduleXCalendar calendarApp={calendar} />;
}
